<template>
  <crm-side-panel @handleClose="handleCloseDetail" :title="projectDetail.name">
    <div class="side-panel-content compact-detail-content">
      <div class="side-panel-header">
        <!-- 合同信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">项目编号</p>
            <p class="info-detail">
              {{ projectDetail.code }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">产品线</p>
            <p class="info-detail">
              {{ projectDetail.productLine }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">项目状态</p>
            <p class="info-detail">
              {{ projectDetail.status }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">所属区域</p>
            <p class="info-detail">
              {{ projectDetail.projectArea }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">最小预算单元</p>
            <el-tooltip
              v-if="projectDetail.minimumBudgetUnit"
              class="item"
              effect="dark"
              :content="projectDetail.minimumBudgetUnit"
              placement="top-start"
            >
              <p class="info-detail">
                {{ projectDetail.minimumBudgetUnit }}
              </p>
            </el-tooltip>
          </div>
          <div class="info-item">
            <p class="info-title">负责人</p>
            <p class="info-detail">
              {{ projectDetail.personCharge }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">申请人</p>
            <p class="info-detail">
              {{ projectDetail.creator }}
            </p>
          </div>
        </div>
      </div>

      <!-- 项目详情各tab项 -->
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" @tab-click="handleClick" :stretch="false">
          <!-- 项目信息tab页 -->
          <el-tab-pane
            v-if="
              authList.length > 0 &&
              !authList[0].disabled &&
              authList[0].value === 'projectOverview'
            "
            label="项目概览"
            name="projectOverview"
            v-loading="loading"
          >
            <crm-pane-info
              v-if="detailBaseInfo.projectBaseInfo"
              :detail="detailBaseInfo"
            ></crm-pane-info>
          </el-tab-pane>

          <!-- 里程碑 -->
          <el-tab-pane
            v-if="
              authList.length > 1 &&
              !authList[1].disabled &&
              authList[1].value === 'milepost'
            "
            label="里程碑"
            name="milepostList"
          >
            <el-table
              :data="milepostList.results"
              v-loading="milepostList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="milepost"
                label="里程碑事件"
                width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="plannedCompletionTime"
                label="计划完成时间"
                align="center"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="actualCompletionTime"
                label="实际完成时间"
                align="center"
                width="200"
              >
              </el-table-column>
              <el-table-column
                prop="personInCharge"
                width="200"
                label="负责人"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100" align="center">
              </el-table-column>
              <el-table-column prop="rate" label="进度说明" width="300" align="center">
              </el-table-column>
              <el-table-column prop="remarks" label="备注" width="300" align="center">
              </el-table-column>
              <el-table-column prop="fruit" label="成果物" width="200" align="center">
              </el-table-column>
              <el-table-column prop="kanoInfos" label="附件" width="200" align="center">
                <template slot-scope="scope">
                  <p v-for="item in scope.row.kanoInfos" :key="item.kanoFileId">
                    <a :href="item.fileUrl" v-if="item.fileUrl">
                      {{ item.fileName }}
                    </a>
                    <span v-else>{{ item.fileName || "暂无数据" }}</span>
                  </p>
                </template>
              </el-table-column>
              <el-table-column prop="updatedBy" label="更新人" width="180" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtModified"
                label="更新时间"
                width="200"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="milepostList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="milepostList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="milepostList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 关键任务 -->
          <el-tab-pane
            v-if="
              authList.length > 2 &&
              !authList[2].disabled &&
              authList[2].value === 'keyTask'
            "
            label="关键任务"
            name="keyTaskList"
          >
            <el-table
              :data="keyTaskList.results"
              v-loading="keyTaskList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="stage" label="阶段" width="200" align="center">
              </el-table-column>
              <el-table-column
                prop="keyTask"
                label="关键任务名称"
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="description"
                label="任务描述"
                width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="plannedBeginTime"
                label="计划开始时间"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="plannedCompletionTime"
                label="计划完成时间"
                align="center"
                width="150"
              >
              </el-table-column>
              <el-table-column
                prop="plannedTime"
                label="计划用时"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="actualBeginTime"
                label="实际开始时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="actualCompletionTime"
                label="实际完成时间"
                align="center"
                width="180"
              >
              </el-table-column>
              <el-table-column prop="status" width="100" label="状态" align="center">
              </el-table-column>
              <el-table-column
                prop="personInCharge"
                label="负责人"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="totalRate" label="总进度" width="100" align="center">
              </el-table-column>
              <el-table-column prop="remarks" label="备注" width="300" align="center">
              </el-table-column>
              <el-table-column prop="updatedBy" label="更新人" width="150" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtModified"
                label="更新时间"
                width="200"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="keyTaskList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="keyTaskList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="keyTaskList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 变更管理 -->
          <el-tab-pane
            v-if="
              authList.length > 3 &&
              !authList[3].disabled &&
              authList[3].value === 'changeManage'
            "
            label="变更管理"
            name="changeManageList"
          >
            <el-table
              :data="changeManageList.results"
              v-loading="changeManageList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="changeDate"
                width="180"
                label="变更日期"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="changeContent"
                width="300"
                label="变更内容"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="affect" width="300" label="影响" align="center">
              </el-table-column>
              <el-table-column
                prop="proposePerson"
                width="150"
                label="提出人"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="reviewStatus"
                label="审核状态"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="reviewerPerson"
                width=" 200"
                label="审核人"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="modifier" label="更新人" width="100" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtModified"
                width="180"
                label="更新时间"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="changeManageList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="changeManageList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="changeManageList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 项目问题 -->
          <el-tab-pane
            v-if="
              authList.length > 4 &&
              !authList[4].disabled &&
              authList[4].value === 'projectProblem'
            "
            label="项目问题"
            name="projectProblemList"
          >
            <el-table
              :data="projectProblemList.results"
              v-loading="projectProblemList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="happenDate"
                width="180"
                label="发生日期"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="description"
                width="300"
                label="问题描述"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="solution"
                label="解决方案"
                width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="personInCharge"
                label="负责人"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="solveDate"
                label="解决日期"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="status" label="问题状态" width="100" align="center">
              </el-table-column>
              <el-table-column prop="updatedBy" label="更新人" width="180" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtModified"
                label="更新时间"
                width="180"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="projectProblemList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="projectProblemList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="projectProblemList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 项目风险 -->
          <el-tab-pane
            v-if="
              authList.length > 5 &&
              !authList[5].disabled &&
              authList[5].value === 'projectRisk'
            "
            label="项目风险"
            name="projectRiskList"
          >
            <el-table
              :data="projectRiskList.results"
              v-loading="projectRiskList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="riskSource"
                width="200"
                label="风险来源"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="riskType"
                label="风险类别"
                width="200"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="riskLevel"
                label="风险等级"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="discoveryTime"
                label="发现时间"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="riskStrategy"
                width="100"
                label="风险策略"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="riskDescription"
                label="风险描述"
                width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="strategyDescription"
                label="策略描述"
                width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="emergencyMethod"
                width="300"
                label="应急措施"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="personInCharge"
                label="责任人"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="status" label="风险状态" width="100" align="center">
              </el-table-column>
              <el-table-column prop="updatedBy" label="更新人" width="100" align="center">
              </el-table-column>
              <el-table-column
                prop="gmtModified"
                label="更新时间"
                width="180"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="projectRiskList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="projectRiskList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="projectRiskList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 所需支持 -->
          <el-tab-pane
            v-if="
              authList.length > 6 &&
              !authList[6].disabled &&
              authList[6].value === 'needSupport'
            "
            label="所需支持"
            name="needSupportList"
          >
            <el-table
              :data="needSupportList.results"
              v-loading="needSupportList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="supportIssue" label="需支持事项" align="center">
              </el-table-column>
              <el-table-column prop="departmentName" label="涉及部门" align="center">
              </el-table-column>
              <el-table-column prop="priority" label="优先级" align="center">
              </el-table-column>
              <el-table-column prop="updatedBy" label="更新人" width="180" align="center">
              </el-table-column>
              <el-table-column prop="gmtModified" label="更新时间" align="center">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="needSupportList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="needSupportList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="needSupportList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 干系人 -->
          <el-tab-pane
            v-if="
              authList.length > 7 &&
              !authList[7].disabled &&
              authList[7].value === 'stakeholder'
            "
            label="干系人"
            name="stakeholderList"
          >
            <el-table
              :data="stakeholderList.results"
              v-loading="stakeholderList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="personInCharge" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="positionName" label="职能" align="center">
              </el-table-column>
              <el-table-column prop="departmentName" label="部门" align="center">
              </el-table-column>
              <el-table-column prop="mobile" label="电话" width="100" align="center">
              </el-table-column>
              <el-table-column prop="remarks" label="备注" align="center">
              </el-table-column>
              <el-table-column prop="updatedBy" label="更新人" width="180" align="center">
              </el-table-column>
              <el-table-column prop="gmtModified" label="更新时间" align="center">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="stakeholderList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="stakeholderList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="stakeholderList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 项目成员 -->
          <el-tab-pane
            v-if="
              authList.length > 8 &&
              !authList[8].disabled &&
              authList[8].value === 'ProjectMember'
            "
            label="项目成员"
            name="projectMemberList"
          >
            <el-table
              :data="projectMemberList.results"
              v-loading="projectMemberList.loading"
              border
              height="100%"
              style="width: 100%"
            >
              <el-table-column prop="employeeNo" label="工号" align="center">
              </el-table-column>
              <el-table-column prop="userName" label="姓名" align="center">
              </el-table-column>
              <el-table-column prop="roleName" label="角色" align="center">
              </el-table-column>
              <el-table-column prop="mobile" label="电话" width="100" align="center">
              </el-table-column>
              <el-table-column prop="email" label="邮箱" align="center">
              </el-table-column>
              <el-table-column prop="modifier" label="更新人" width="180" align="center">
              </el-table-column>
              <el-table-column prop="gmtModified" label="更新时间" align="center">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="projectMemberList.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="projectMemberList.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="projectMemberList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
  </crm-side-panel>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import CrmSidePanel from "~component/base/crmSidePanel.vue";
import CrmButton from "@/components/base/crmButton";
import CrmPaneInfo from "./crmPaneInfo.vue";
import AddProject from "~component/business/project/addProject.vue";
import service from "~api/project";

export default {
  components: {
    CrmSidePanel,
    CrmButton,
    CrmPaneInfo,
    AddProject,
  },
  props: {
    detailId: String,
    projectId: String,
    detailTabName: String,
    authList: Array,
  },
  data() {
    return {
      loading: false,
      projectDetail: {},
      detailBaseInfo: {},
      isRefresh: false,
      activeTab: "projectOverview",
      packageLoading: false,
      imagePreview: {
        showImage: false,
        url: "",
      },
      milepostList: {
        pageNumber: 1,
        pageSize: 5,
        results: [],
        totalCount: null,
        loading: false,
      },
      keyTaskList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
      changeManageList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
      projectProblemList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
      projectRiskList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
      needSupportList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
      stakeholderList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
      projectMemberList: {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      projectPackage: "project/projectPackage",
    }),
  },
  watch: {
    detailId: {
      handler(val) {
        if (val) {
          this.handleQueryDetail();
          this.isRefresh = false;
          const activedList = this.authList.filter((item) => {
            return !item.disabled;
          });
          const transforMap = {
            projectOverview: "projectOverview",
            milepost: "milepostList",
            keyTask: "keyTaskList",
            changeManage: "changeManageList",
            projectProblem: "projectProblemList",
            projectRisk: "projectRiskList",
            needSupport: "needSupportList",
            stakeholder: "stakeholderList",
            ProjectMember: "projectMemberList",
            "": "projectOverview",
          };
          this.activeTab = activedList[0]?.value
            ? transforMap[activedList[0]?.value]
            : "projectOverview";
          this.handleGetTabData(this.activeTab);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({}),
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    // 基础信息
    handleQueryDetail() {
      this.loading = true;
      service
        .queryBasicInfo({ id: this.detailId })
        .then((res) => {
          this.projectDetail = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCloseDetail() {
      this.$emit("handleCloseDetail", this.isRefresh);
    },
    handleStopHideDialog(events) {
      events.stopPropagation();
    },
    // tab 切换
    handleClick(val) {
      this.milepostList = {
        pageNumber: 1,
        pageSize: 5,
        results: [],
        totalCount: null,
        loading: false,
      };
      this.keyTaskList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.changeManageList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.projectProblemList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.projectRiskList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.needSupportList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.stakeholderList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.projectMemberList = {
        pageNumber: 1,
        pageSize: 5,
        totalCount: null,
        results: [],
        loading: false,
      };
      this.handleGetTabData();
    },
    handleCurrentChange(val) {
      this[this.activeTab].pageNumber = val || 1;
      this.handleGetTabData();
    },
    handleGetTabData() {
      switch (this.activeTab) {
        case "projectOverview":
          this.queryCrmProjectDetail();
          break;
        // 里程碑
        case "milepostList":
          this.handleGetMilepost();
          break;
        // 关键任务
        case "keyTaskList":
          this.handleGetKeyTask();
          break;
        // 变更管理
        case "changeManageList":
          this.handleGetChangeManage();
          break;
        // 项目问题
        case "projectProblemList":
          this.handleGetProjectProblem();
          break;
        // 项目风险
        case "projectRiskList":
          this.handleGetProjectRisk();
          break;
        // 所需支持
        case "needSupportList":
          this.handleGetNeedSupport();
          break;
        // 干系人
        case "stakeholderList":
          this.handleGetStakeholder();
          break;
        // 项目成员
        case "projectMemberList":
          this.handleGetProjectMember();
          break;
        default:
          break;
      }
    },
    // 里程碑
    handleGetMilepost() {
      this.milepostList.loading = true;
      service
        .queryProjectMilestone({
          projectId: this.projectId,
          pageSize: this.milepostList.pageSize,
          pageNumber: this.milepostList.pageNumber,
        })
        .then((res) => {
          this.milepostList = res.data;
          this.milepostList.loading = false;
        });
    },
    // 关键任务
    handleGetKeyTask() {
      this.keyTaskList.loading = true;
      service
        .queryProjectKeyTask({
          projectId: this.projectId,
          pageSize: this.keyTaskList.pageSize,
          pageNumber: this.keyTaskList.pageNumber,
        })
        .then((res) => {
          this.keyTaskList = res.data;
          this.keyTaskList.loading = false;
        });
    },
    // 变更管理
    handleGetChangeManage() {
      this.changeManageList.loading = true;
      service
        .queryProjectChangeManage({
          projectId: this.projectId,
          pageSize: this.changeManageList.pageSize,
          pageNumber: this.changeManageList.pageNumber,
        })
        .then((res) => {
          this.changeManageList = res.data;
          this.changeManageList.loading = false;
        });
    },
    // 项目问题
    handleGetProjectProblem() {
      this.projectProblemList.loading = true;
      service
        .queryProjectProblem({
          projectId: this.projectId,
          pageSize: this.projectProblemList.pageSize,
          pageNumber: this.projectProblemList.pageNumber,
        })
        .then((res) => {
          this.projectProblemList = res.data;
          this.projectProblemList.loading = false;
        });
    },
    // 项目风险
    handleGetProjectRisk() {
      this.projectRiskList.loading = true;
      service
        .queryProjectRisk({
          projectId: this.projectId,
          pageSize: this.projectRiskList.pageSize,
          pageNumber: this.projectRiskList.pageNumber,
        })
        .then((res) => {
          this.projectRiskList = res.data;
          this.projectRiskList.loading = false;
        });
    },
    // 所需支持
    handleGetNeedSupport() {
      this.needSupportList.loading = true;
      service
        .queryProjectSupport({
          projectId: this.projectId,
          pageSize: this.needSupportList.pageSize,
          pageNumber: this.needSupportList.pageNumber,
        })
        .then((res) => {
          this.needSupportList = res.data;
          this.needSupportList.loading = false;
        });
    },
    // 干系人
    handleGetStakeholder() {
      this.stakeholderList.loading = true;
      service
        .queryProjectStakeholder({
          projectId: this.projectId,
          pageSize: this.stakeholderList.pageSize,
          pageNumber: this.stakeholderList.pageNumber,
        })
        .then((res) => {
          this.stakeholderList = res.data;
          this.stakeholderList.loading = false;
        });
    },
    // 项目成员
    handleGetProjectMember() {
      this.projectMemberList.loading = true;
      service
        .queryProjectMember({
          projectId: this.projectId,
          pageSize: this.projectMemberList.pageSize,
          pageNumber: this.projectMemberList.pageNumber,
        })
        .then((res) => {
          this.projectMemberList = res.data;
          this.projectMemberList.loading = false;
        });
    },
    // 查询基础详情
    queryCrmProjectDetail() {
      service.queryCrmProjectDetail({ projectId: this.projectId }).then((res) => {
        this.detailBaseInfo = res.data;
      });
    },
    handleGetCostList() {
      this.costLoading = true;
      const { pageSize, pageNumber } = this.cost;
      this.getCompactCostList({
        contractId: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.compactCostData.results.length === 0 && pageNumber !== 1) {
          this.cost.pageNumber = 1;
          this.handleGetCostList();
        } else {
          this.costLoading = false;
        }
      });
    },
    handleGetPayList() {
      this.addPayDialog.payLoading = true;
      const { pageSize, pageNumber } = this.pay;
      this.getPayDataList({
        contractId: this.detailId,
        pageSize,
        pageNumber,
      }).finally(() => {
        if (this.payDataList.results.length === 0 && pageNumber !== 1) {
          this.pay.pageNumber = 1;
          this.handleGetPayList();
        } else {
          this.addPayDialog.payLoading = false;
        }
      });
    },
    handleSizeChange(val) {
      this[this.activeTab].pageSize = val;
      this[this.activeTab].pageNumber = 1;
      this.handleGetTabData();
    },
  },
};
</script>

<style lang="less">
.compact-detail-content {
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
.busi-dialog {
  padding: 0 30px;
  .el-form-item__label {
    float: none;
  }
}
.dialog-title {
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
}
.returnd-money-wrap {
  width: 100%;
  border-top: 1px dashed #cccccc;
  .returnd-money-title {
    width: 60px;
    background-color: #ffffff;
    margin-top: -12px;
  }
  .icon-delete {
    cursor: pointer;
    text-align: center;
    font-size: 20px;
    margin-left: -130px;
    color: #f56c6c;
  }
}
.date-add-return {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100% !important;
  }
}
</style>
